import { IconButton } from '../icon-button'
import { Bar } from '../bar'
import style from "./index.module.css"

export const PlusIcon = () => {
    const base = IconButton()
    base.addClass(style.base)

    // --brand-icon is the brand purple on light, a light lavender on the night sky.
    const v = Bar(4, { bg: 'var(--brand-icon)' })
    const h = Bar(4, { bg: 'var(--brand-icon)' })

    v.style({
        transform: 'rotate(90deg) translateX(10px)'
    })
    h.style({
        transform: 'translateY(6px)'
    })
    base.append(v, h)


    return base
};
